import { ApiDataAccess, Dictionary, ReadonlyHttpApiRepository } from '@softline/core';
import { Product } from '@softapps/wws/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT } from '../artikelstamm.api';
import { ProductQuery } from '../types/product.query';

@Injectable()
export class ProductRepository extends ReadonlyHttpApiRepository<Product, ProductQuery> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT);
  }

  override getLoadPathParams(params: ProductQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
